(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8518],{

/***/ 77479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ MainBlock; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var aphrodite__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34397);
/* harmony import */ var _MainBlockStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36745);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);


var _excluded = ["styles", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var MainBlock = function MainBlock(props) {
  var styles = props.styles,
      children = props.children,
      rest = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", _objectSpread(_objectSpread({
    className: (0,aphrodite__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_MainBlockStyle__WEBPACK_IMPORTED_MODULE_3__/* .MainBlockStyle.block */ .d.block, styles)
  }, rest), {}, {
    children: children
  }));
};

/***/ }),

/***/ 36745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ MainBlockStyle; }
/* harmony export */ });
/* harmony import */ var aphrodite__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34397);

var MainBlockStyle = aphrodite__WEBPACK_IMPORTED_MODULE_0__/* .StyleSheet.create */ .mM.create({
  block: {
    boxSizing: "border-box"
  }
});

/***/ }),

/***/ 59941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* reexport safe */ _MainBlock__WEBPACK_IMPORTED_MODULE_1__.R; }
/* harmony export */ });
/* harmony import */ var _MainBlockStyle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36745);
/* harmony import */ var _MainBlock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77479);



/***/ }),

/***/ 84026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H2": function() { return /* reexport */ H2; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/H2/H2Style.ts




var H2Style = es/* StyleSheet.create */.mM.create({
  h2: {
    fontSize: typographyStyle/* fontSize.headline */.JB.headline,
    lineHeight: typographyStyle/* lineHeight.headline2 */.Nv.headline2,
    fontWeight: typographyStyle/* fontWeight.regular */.Ue.regular,
    color: colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor,
    padding: "calc(".concat(spaceStyle/* space.atom */.D.atom, " - (").concat(typographyStyle/* lineHeight.headline2 */.Nv.headline2, " - ").concat(typographyStyle/* fontSize.headline */.JB.headline, ")/2) ").concat(spaceStyle/* space.atom */.D.atom),
    margin: 0
  }
});
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/H2/H2.tsx




var H2 = function H2(props) {
  var styles = props.styles,
      children = props.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
    className: (0,es/* css */.iv)(H2Style.h2, styles),
    children: children
  });
};
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/H2/index.ts


/***/ }),

/***/ 39733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ CardTitle; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36716);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80910);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);


var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var CardTitle = function CardTitle(props) {
  var children = props.children,
      rest = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(props, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", _objectSpread(_objectSpread({
    css: cardTitleStyle
  }, rest), {}, {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("h3", {
      css: cardTitleTextStyle,
      children: children
    })
  }));
};
var cardTitleStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)("align-items:center;color:rgb(0, 0, 0);display:flex;perspective-origin:165px 56px;transform-origin:165px 56px;box-sizing:border-box;padding:calc(\n      ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__/* .space.atom */ .D.atom, " -\n        (", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .lineHeight.mediumHeadline2 */ .Nv.mediumHeadline2, " - ", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .fontSize.mediumHeading */ .JB.mediumHeading, ") / 2\n    ) ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__/* .space.atom */ .D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var cardTitleTextStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)("align-self:flex-end;display:flex;font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .fontSize.mediumHeading */ .JB.mediumHeading, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .lineHeight.mediumHeadline2 */ .Nv.mediumHeadline2, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .fontWeight.bold */ .Ue.bold, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_4__/* .textColor.primaryDarkColor */ .zP.primaryDarkColor, ";overflow:hidden;transform-origin:149px 48px;margin:0;" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 65562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ HotelDatePickerBlock; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(16835);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(70917);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(87536);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(32912);
/* harmony import */ var react_fast_compare__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69590);
/* harmony import */ var react_fast_compare__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_fast_compare__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26793);
/* harmony import */ var main_javascripts_components_hotel_form_CheckinInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27114);
/* harmony import */ var main_javascripts_components_hotel_form_CheckoutInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82011);
/* harmony import */ var main_javascripts_components_molecules_Modal_FullScreenModalDialog__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19484);
/* harmony import */ var main_javascripts_components_molecules_DatePicker__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31264);
/* harmony import */ var main_javascripts_constants_HotelConstants__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(10780);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88433);
/* harmony import */ var main_javascripts_components_molecules_DatePicker_HorizontalDatePicker__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16201);
/* harmony import */ var main_javascripts_constants_DateTypes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71797);
/* harmony import */ var main_javascripts_utils_DateUtil__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(16341);
/* harmony import */ var _styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96749);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14416);
/* harmony import */ var _utils_googleTagManagerUtil__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(49224);
/* harmony import */ var _constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(12327);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(35944);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }























var HotelDatePickerBlockComponent = function HotelDatePickerBlockComponent(props) {
  var _props$labelColorStyl = props.labelColorStyleKey,
      labelColorStyleKey = _props$labelColorStyl === void 0 ? "default" : _props$labelColorStyl,
      borderColorStyleKey = props.borderColorStyleKey,
      disableStopBodyScrolling = props.disableStopBodyScrolling;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_13__/* .useTranslation */ .$)(["component"]),
      t = _useTranslation.t; // TODO: 旧reducerをそのまま使用


  var breakpoint = (0,react_redux__WEBPACK_IMPORTED_MODULE_10__/* .useSelector */ .v9)(function (state) {
    return state.breakpointReducer.breakpoint;
  });

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_14__/* .useFormContext */ .Gc)(),
      setValue = _useFormContext.setValue,
      control = _useFormContext.control,
      trigger = _useFormContext.trigger;

  var _useWatch = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_14__/* .useWatch */ .qo)({
    control: control,
    name: ["checkin_date", "checkout_date"]
  }),
      _useWatch2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_useWatch, 2),
      checkinDateValue = _useWatch2[0],
      checkoutDateValue = _useWatch2[1];

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      displayedPicker = _useState[0],
      setDisplayedPicker = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      pickerDateType = _useState2[0],
      setPickerDateType = _useState2[1];

  var inputCheckInRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var inputCheckOutRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(); // public shouldComponentUpdate(nextProps: any, nextState: any): boolean {
  //   return !isEqual(props, nextProps) || !isEqual(state, nextState);
  // }

  var onClickCheckinDate = function onClickCheckinDate() {
    setDisplayedPicker(true);
    setPickerDateType(main_javascripts_constants_DateTypes__WEBPACK_IMPORTED_MODULE_8__/* .DateTypes.fromDate */ .t.fromDate);
  };

  var onClickCheckoutDate = function onClickCheckoutDate() {
    setDisplayedPicker(true);
    setPickerDateType(main_javascripts_constants_DateTypes__WEBPACK_IMPORTED_MODULE_8__/* .DateTypes.toDate */ .t.toDate);
  };

  var sendDateEvent = function sendDateEvent(checkinDateString, checkoutDateString) {
    if (checkinDateString && checkoutDateString) {
      (0,_utils_googleTagManagerUtil__WEBPACK_IMPORTED_MODULE_11__/* .event */ .B)(_constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_12__/* .GoogleTagManagerEventTypes.date */ .T.date, {
        start_date: checkinDateString,
        end_date: checkoutDateString
      });
    }
  };

  var onComplete = function onComplete(startDate, endDate) {
    var checkinDateString = "";
    var checkoutDateString = "";

    if (startDate) {
      checkinDateString = (0,date_fns__WEBPACK_IMPORTED_MODULE_16__["default"])(startDate, "yyyy/LL/dd");
      setValue("checkin_date", checkinDateString);
      void trigger(["checkin_date"]);
    }

    if (endDate) {
      checkoutDateString = (0,date_fns__WEBPACK_IMPORTED_MODULE_16__["default"])(endDate, "yyyy/LL/dd");
      setValue("checkout_date", checkoutDateString);
      void trigger(["checkout_date"]);
    }

    sendDateEvent(checkinDateString, checkoutDateString);
    hidePicker();
  };

  var onUpdate = function onUpdate(startDate, endDate, isEndStep) {
    var checkinDateString = "";
    var checkoutDateString = "";

    if (startDate) {
      checkinDateString = (0,date_fns__WEBPACK_IMPORTED_MODULE_16__["default"])(startDate, "yyyy/LL/dd");
      setValue("checkin_date", checkinDateString);
      void trigger(["checkin_date"]);
    }

    if (endDate) {
      checkoutDateString = (0,date_fns__WEBPACK_IMPORTED_MODULE_16__["default"])(endDate, "yyyy/LL/dd");
      setValue("checkout_date", checkoutDateString);
      void trigger(["checkout_date"]);
    }

    if (!isEndStep) {
      setPickerDateType(main_javascripts_constants_DateTypes__WEBPACK_IMPORTED_MODULE_8__/* .DateTypes.toDate */ .t.toDate);
    }

    sendDateEvent(checkinDateString, checkoutDateString);
  };

  var hidePicker = function hidePicker() {
    setDisplayedPicker(false);
    setPickerDateType(null);
  }; // 再レンダリングの負荷が高い場合はメモ化検討する


  var fromDate = checkinDateValue ? (0,main_javascripts_utils_DateUtil__WEBPACK_IMPORTED_MODULE_17__/* .parseDate */ .s)(checkinDateValue) : null;
  var toDate = checkoutDateValue ? (0,main_javascripts_utils_DateUtil__WEBPACK_IMPORTED_MODULE_17__/* .parseDate */ .s)(checkoutDateValue) : null;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)("div", {
    css: blockStyle,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)("div", {
      css: inputBlockStyle,
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(main_javascripts_components_hotel_form_CheckinInput__WEBPACK_IMPORTED_MODULE_2__/* .CheckinInput */ .a, {
        namespace: "hotel",
        isActive: pickerDateType === main_javascripts_constants_DateTypes__WEBPACK_IMPORTED_MODULE_8__/* .DateTypes.fromDate */ .t.fromDate,
        onClick: onClickCheckinDate,
        labelColorStyleKey: labelColorStyleKey,
        borderColorStyleKey: borderColorStyleKey,
        inputBlockRef: inputCheckInRef
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(main_javascripts_components_hotel_form_CheckoutInput__WEBPACK_IMPORTED_MODULE_3__/* .CheckoutInput */ .a, {
        namespace: "hotel",
        isActive: pickerDateType === main_javascripts_constants_DateTypes__WEBPACK_IMPORTED_MODULE_8__/* .DateTypes.toDate */ .t.toDate,
        onClick: onClickCheckoutDate,
        labelColorStyleKey: labelColorStyleKey,
        borderColorStyleKey: borderColorStyleKey,
        inputBlockRef: inputCheckOutRef
      })]
    }), (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__/* .isPhone */ .Mn)(breakpoint) ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(main_javascripts_components_molecules_Modal_FullScreenModalDialog__WEBPACK_IMPORTED_MODULE_4__/* .FullScreenModalDialog */ .H, {
      displayed: displayedPicker,
      closeHandler: hidePicker,
      colorMode: "light",
      disableStopBodyScrolling: disableStopBodyScrolling,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(main_javascripts_components_molecules_DatePicker__WEBPACK_IMPORTED_MODULE_5__/* .ScrollableDatePicker */ .d, {
        fromDate: fromDate,
        toDate: toDate,
        onComplete: onComplete,
        numberOfMonths: 12,
        maxDays: main_javascripts_constants_HotelConstants__WEBPACK_IMPORTED_MODULE_19__/* .MAX_SEARCH_HOTEL_DAYS */ ._r,
        outOfRangeMessage: t("search.calendarMaxDaysMessage"),
        startDateLabel: t("label:common.checkinDate"),
        endDateLabel: t("label:common.checkoutDate"),
        dateType: pickerDateType
      })
    }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(main_javascripts_components_molecules_DatePicker_HorizontalDatePicker__WEBPACK_IMPORTED_MODULE_7__/* .HorizontalDatePicker */ .R, {
      fromDate: fromDate,
      toDate: toDate,
      onUpdate: onUpdate,
      hidePicker: hidePicker,
      numberOfMonths: 12,
      maxDays: main_javascripts_constants_HotelConstants__WEBPACK_IMPORTED_MODULE_19__/* .MAX_SEARCH_HOTEL_DAYS */ ._r,
      outOfRangeMessage: t("search.calendarMaxDaysMessage"),
      startDateLabel: t("label:common.checkinDate"),
      endDateLabel: t("label:common.checkoutDate"),
      displayedPicker: displayedPicker,
      dateType: pickerDateType,
      fromInputRef: inputCheckInRef.current,
      toInputRef: inputCheckOutRef.current
    })]
  });
};

var areEqual = function areEqual(prevProps, nextProps) {
  return react_fast_compare__WEBPACK_IMPORTED_MODULE_1___default()(prevProps, nextProps);
};

var HotelDatePickerBlock = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(HotelDatePickerBlockComponent, areEqual);
var blockStyle =  true ? {
  name: "3ldklc",
  styles: "position:relative;flex:1"
} : 0;
var inputBlockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_20__.css)("display:flex;padding:", _styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_9__/* .space.atom */ .D.atom, " 0 0;" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 99581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* reexport */ Breadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Breadcrumb/BreadcrumbStyle.ts




var BreadcrumbStyle = es/* StyleSheet.create */.mM.create({
  ul: {
    listStyleType: "none",
    padding: "".concat(spaceStyle/* space.atom */.D.atom, " ").concat(spaceStyle/* space.atom */.D.atom, " ").concat(spaceStyle/* space.atom0_5x */.D.atom0_5x)
  },
  list: {
    display: "inline-block",
    fontSize: typographyStyle/* fontSize.caption */.JB.caption,
    lineHeight: typographyStyle/* lineHeight.caption3 */.Nv.caption3,
    color: colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor,
    marginBottom: spaceStyle/* space.atom0_5x */.D.atom0_5x,
    ":after": {
      content: '"/"',
      color: colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor,
      padding: "0 ".concat(spaceStyle/* space.atom */.D.atom),
      opacity: 0.7
    },
    ":last-child": {
      ":after": {
        content: "none"
      }
    }
  },
  span: {
    color: colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor,
    textDecoration: "none"
  },
  link: {
    color: colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor,
    transition: "color 0.4s ease",
    ":hover": {
      color: colorStyle/* accentColor.primaryColor */.z.primaryColor
    }
  }
});
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Breadcrumb/Breadcrumb.tsx




var Breadcrumb = function Breadcrumb(props) {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
    className: (0,es/* css */.iv)(BreadcrumbStyle.ul),
    children: props.linkData.map(function (data, index) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
        className: (0,es/* css */.iv)(BreadcrumbStyle.list),
        children: data.url ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
          href: data.url,
          className: (0,es/* css */.iv)(BreadcrumbStyle.link),
          children: data.label
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
          className: (0,es/* css */.iv)(BreadcrumbStyle.span),
          children: data.label
        })
      }, index);
    })
  });
};
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Breadcrumb/index.ts


/***/ }),

/***/ 7696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ BlockTitle; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/H2/index.ts + 2 modules
var H2 = __webpack_require__(84026);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Lp/BlockTitle/BlockTitleStyle.ts






var BlockTitleStyle = es/* StyleSheet.create */.mM.create({
  block: {
    padding: spaceStyle/* space.atom */.D.atom
  },
  title: (0,defineProperty/* default */.Z)({
    fontSize: typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading,
    lineHeight: typographyStyle/* lineHeight.headline1 */.Nv.headline1,
    color: colorStyle/* accentColor.secondaryColor2 */.z.secondaryColor2,
    padding: spaceStyle/* space.atom */.D.atom,
    fontWeight: typographyStyle/* fontWeight.bold */.Ue.bold,
    letterSpacing: "0.1em",
    margin: "0.5rem 0",
    position: "relative",
    paddingBottom: spaceStyle/* space.atom2x */.D.atom2x,
    ":before": {
      content: "''",
      position: "absolute",
      bottom: 0,
      display: "block",
      height: "1px",
      width: "calc(100% - ".concat(spaceStyle/* space.atom2x */.D.atom2x, ")"),
      background: colorStyle/* borderColor.primaryLightColor */.tv.primaryLightColor
    },
    ":after": {
      content: "''",
      position: "absolute",
      bottom: 0,
      display: "block",
      height: "1px",
      width: "3rem",
      background: colorStyle/* accentColor.primaryColor */.z.primaryColor
    }
  }, (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), {
    fontSize: typographyStyle/* fontSize.headline */.JB.headline
  })
});
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Lp/BlockTitle/BlockTitle.tsx




var BlockTitle = function BlockTitle(props) {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H2.H2, {
    styles: [BlockTitleStyle.title, props.styles],
    children: props.children
  });
};
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Lp/BlockTitle/index.ts


/***/ }),

/***/ 93478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* reexport */ RegionList; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Lp/RegionList/RegionListStyle.ts


var _list;






var RegionListStyle = es/* StyleSheet.create */.mM.create({
  block: {
    padding: spaceStyle/* space.atom */.D.atom,
    display: "flex",
    flexWrap: "wrap",
    listStyle: "none"
  },
  list: (_list = {
    fontSize: typographyStyle/* fontSize.caption */.JB.caption,
    lineHeight: typographyStyle/* lineHeight.caption3 */.Nv.caption3,
    color: colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor,
    padding: "".concat(spaceStyle/* space.atom */.D.atom, " ").concat(spaceStyle/* space.atom */.D.atom, " ").concat(spaceStyle/* space.atom */.D.atom, " ").concat(spaceStyle/* space.atom2x */.D.atom2x),
    marginBottom: spaceStyle/* space.atom0_5x */.D.atom0_5x,
    letterSpacing: "0.1em",
    position: "relative",
    width: "100%",
    boxSizing: "border-box",
    ":before": {
      content: "''",
      position: "absolute",
      top: "1rem",
      left: 0,
      display: "block",
      height: "1px",
      width: spaceStyle/* space.atom */.D.atom,
      background: colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor
    }
  }, (0,defineProperty/* default */.Z)(_list, (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), {
    width: "50%"
  }), (0,defineProperty/* default */.Z)(_list, (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), {
    width: "25%"
  }), _list),
  link: {
    color: colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor,
    textDecoration: "none",
    transition: "color 0.4s ease",
    ":hover": {
      color: colorStyle/* accentColor.primaryColor */.z.primaryColor
    }
  }
});
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Lp/RegionList/RegionList.tsx




var RegionList = function RegionList(props) {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
    className: (0,es/* css */.iv)(RegionListStyle.block),
    children: props.regions.map(function (region, index) {
      var region_path = region.code || region.id;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
        className: (0,es/* css */.iv)(RegionListStyle.list),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
          className: (0,es/* css */.iv)(RegionListStyle.link),
          href: "".concat(props.linkUrl).concat(region_path),
          children: region.name
        })
      }, index);
    })
  });
};
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Lp/RegionList/index.ts


/***/ }),

/***/ 10780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ky": function() { return /* binding */ DEFAULT_ADULTS; },
/* harmony export */   "_r": function() { return /* binding */ MAX_SEARCH_HOTEL_DAYS; },
/* harmony export */   "yW": function() { return /* binding */ MAX_NUMBER_OF_ROOMS; }
/* harmony export */ });
/* unused harmony export MAX_ADULTS */
var MAX_SEARCH_HOTEL_DAYS = 28;
var MAX_NUMBER_OF_ROOMS = 9;
var MAX_ADULTS = 10;
var DEFAULT_ADULTS = 2;

/***/ }),

/***/ 87687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bg": function() { return /* binding */ PostTrackingLinkDomains; },
/* harmony export */   "YF": function() { return /* binding */ POST_SLUG; },
/* harmony export */   "fy": function() { return /* binding */ PostSearchGAParams; }
/* harmony export */ });
/* unused harmony export LINE_ADD_FRIEND_URL */
var POST_SLUG =  false ? 0 : "posts";
var LINE_ADD_FRIEND_URL = "https://lin.ee/tlg2Tnc";
var PostSearchGAParams = {
  utm_campaign: "line_ta1",
  utm_medium: "organic",
  utm_source: "tarip"
};
var PostTrackingLinkDomains = ["liff.line.me"];

/***/ }),

/***/ 28048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ir": function() { return /* binding */ pushUrl; }
/* harmony export */ });
/* unused harmony exports getAbsoluteUrl, getBasePath */
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56264);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(humps__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ObjectUtil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76614);



function getAbsoluteUrl(req) {
  var setLocalhost = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var protocol = "https:";
  var host = req ? req.headers["x-forwarded-host"] || req.headers["host"] : window.location.host;

  if (host.indexOf("localhost") > -1) {
    if (setLocalhost) host = setLocalhost;
    protocol = "http:";
  }

  return {
    protocol: protocol,
    host: host,
    origin: protocol + "//" + host
  };
}
function pushUrl(param, router) {
  // console.log(router);
  var path = getBasePath(router.asPath);
  var queryParam = (0,humps__WEBPACK_IMPORTED_MODULE_0__.decamelizeKeys)((0,_ObjectUtil__WEBPACK_IMPORTED_MODULE_2__/* .removeEmpty */ .HO)(param));
  var newUrl = "".concat(path, "?").concat((0,qs__WEBPACK_IMPORTED_MODULE_1__.stringify)(queryParam, {
    arrayFormat: "indices"
  }));

  if (location.hash) {
    newUrl += location.hash; // lineなどがaccessTokenなどをくっつけてるため
  } // shallow: trueにしないと再度サーバーサイドの処理が動作してしまうため注意


  router.push(newUrl, null, {
    shallow: true
  });
}
function getBasePath(url) {
  var pathWithoutHash = url.split("#")[0];
  return pathWithoutHash.split("?")[0];
}

/***/ }),

/***/ 18125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _regionId_; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/I18nextProvider.js
var I18nextProvider = __webpack_require__(6339);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./main/javascripts/store.ts + 1 modules
var store = __webpack_require__(79169);
// EXTERNAL MODULE: ./main/javascripts/containers/organisms/Header/HeaderContainer.ts
var HeaderContainer = __webpack_require__(12664);
// EXTERNAL MODULE: ./main/javascripts/styles/globalStyle.ts
var globalStyle = __webpack_require__(15305);
// EXTERNAL MODULE: ./i18n.ts + 313 modules
var i18n = __webpack_require__(44349);
// EXTERNAL MODULE: ./main/javascripts/constants/Constants.ts
var Constants = __webpack_require__(25968);
// EXTERNAL MODULE: ./main/javascripts/components/head/MainHead.tsx + 2 modules
var MainHead = __webpack_require__(65025);
// EXTERNAL MODULE: ./main/javascripts/hooks/common/useConstructor.ts
var useConstructor = __webpack_require__(83795);
// EXTERNAL MODULE: ./main/javascripts/hooks/common/useUserAccount.tsx
var useUserAccount = __webpack_require__(30522);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Block/MainBlock/index.ts
var MainBlock = __webpack_require__(59941);
// EXTERNAL MODULE: ./main/javascripts/components/search/SearchBlock.tsx
var SearchBlock = __webpack_require__(44112);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addMonths/index.js
var addMonths = __webpack_require__(11640);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(77349);
// EXTERNAL MODULE: ./node_modules/date-fns-tz/index.js
var date_fns_tz = __webpack_require__(70722);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./main/javascripts/components/hotel/GuestsBlock.tsx + 3 modules
var GuestsBlock = __webpack_require__(88452);
// EXTERNAL MODULE: ./main/javascripts/components/button/ButtonWithLoader.tsx + 1 modules
var ButtonWithLoader = __webpack_require__(51185);
// EXTERNAL MODULE: ./main/javascripts/components/hotel/HotelDatePickerBlock.tsx
var HotelDatePickerBlock = __webpack_require__(65562);
// EXTERNAL MODULE: ./main/javascripts/constants/FormConstants.ts
var FormConstants = __webpack_require__(36581);
// EXTERNAL MODULE: ./main/javascripts/features/hotel/hotelSuggestionSlice.ts
var hotelSuggestionSlice = __webpack_require__(86058);
// EXTERNAL MODULE: ./main/javascripts/components/hotel/HotelDestinationBlock.tsx
var HotelDestinationBlock = __webpack_require__(83981);
// EXTERNAL MODULE: ./main/javascripts/components/form/FormErrorsBlock.tsx + 2 modules
var FormErrorsBlock = __webpack_require__(59557);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
// EXTERNAL MODULE: ./main/javascripts/features/hotel/searchHotelSlice.ts
var searchHotelSlice = __webpack_require__(9296);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(95094);
// EXTERNAL MODULE: ./main/javascripts/utils/googleTagManagerUtil.ts
var googleTagManagerUtil = __webpack_require__(49224);
// EXTERNAL MODULE: ./main/javascripts/utils/FormUtil.ts
var FormUtil = __webpack_require__(63591);
// EXTERNAL MODULE: ./main/javascripts/features/lp/hotelDstRegion/lpHotelDstRegionSlice.ts
var lpHotelDstRegionSlice = __webpack_require__(48161);
// EXTERNAL MODULE: ./main/javascripts/styles/base/maxWidthStyle.ts
var maxWidthStyle = __webpack_require__(79105);
// EXTERNAL MODULE: ./main/javascripts/constants/PostConstants.ts
var PostConstants = __webpack_require__(87687);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/features/lp/hotelDstRegion/components/SearchHotel.tsx



var _excluded = ["text"];


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
































yup_es/* setLocale */.i_(FormConstants/* yupDefaultMessages */.b);
var schema = yup_es/* object */.Ry().shape({
  destination: yup_es/* string */.Z_().nullable().required(),
  destination_id: yup_es/* number */.Rx().nullable().transform(function (_, val) {
    return val ? Number(val) : null;
  }).required(),
  checkin_date: yup_es/* string */.Z_().nullable().required(),
  checkout_date: yup_es/* string */.Z_().nullable().required(),
  guests: yup_es/* array */.IX().of(yup_es/* object */.Ry().shape({
    number_of_children: yup_es/* number */.Rx().nullable().transform(function (_, val) {
      return val || val === 0 ? Number(val) : null;
    }).required(),
    ages_of_children: yup_es/* array */.IX().when("number_of_children", {
      is: function is(val) {
        return Number(val) > 0;
      },
      then: yup_es/* array */.IX().of(yup_es/* object */.Ry().shape({
        age: yup_es/* number */.Rx().nullable().transform(function (_, val) {
          return val || val === 0 ? Number(val) : null;
        }).required()
      }))
    })
  }))
});
var defaultValues = {
  destination: "",
  checkin_date: null,
  // undefinedではダメ
  checkout_date: null,
  // undefinedではダメ
  number_of_rooms: 1,
  guests: [{
    number_of_adult: 2,
    number_of_children: 0,
    ages_of_children: []
  }]
};
var SearchHotel = function SearchHotel() {
  var _region;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["component"]),
      t = _useTranslation.t;

  var appDispatch = (0,store/* useAppDispatch */.TL)();

  var _useState = (0,react.useState)(false),
      isSubmitting = _useState[0],
      setIsSubmitting = _useState[1];

  var hotelDestinationRegion = (0,store/* useAppSelector */.CG)(lpHotelDstRegionSlice/* hotelDestinationRegionSelector */.VE);
  var initialValues = {};
  var region = null;

  if (hotelDestinationRegion) {
    region = hotelDestinationRegion.region;

    if (region) {
      initialValues.destination_id = region.id;
      initialValues.destination = region.name;
      initialValues.destination_type = "region";
      initialValues.latitude = region.latitude;
      initialValues.longitude = region.longitude;
    }

    var today = new Date();
    var departureDate = (0,addMonths["default"])(today, 2);
    var dateFormat = "yyyy/LL/dd";
    var timeZone = "Asia/Tokyo";
    initialValues.checkin_date = (0,date_fns_tz.formatInTimeZone)(departureDate, timeZone, dateFormat);
    initialValues.checkout_date = (0,date_fns_tz.formatInTimeZone)((0,addDays["default"])(departureDate, 5), timeZone, dateFormat);
  }

  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onSubmit",
    resolver: (0,yup/* yupResolver */.X)(schema),
    defaultValues: _objectSpread(_objectSpread({}, defaultValues), initialValues)
  });
  var handleSubmit = methods.handleSubmit,
      setError = methods.setError,
      clearErrors = methods.clearErrors,
      errors = methods.formState.errors;

  var handleFormSubmit = function handleFormSubmit(e) {
    e.preventDefault();
    clearErrors("form");
    handleSubmit(onSubmit)(e);
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values) {
      var submitValues;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              submitValues = (0,searchHotelSlice/* convertSearchHotelFormValuesToParams */.Dh)(values);
              setIsSubmitting(true);
              return _context.abrupt("return", appDispatch((0,searchHotelSlice/* postSearchHotelCache */.Yw)({
                params: submitValues
              })).then(redux_toolkit_esm/* unwrapResult */.SI).then(function (result) {
                var cacheId = result.data.cacheId;
                (0,googleTagManagerUtil/* hotelAvailabilitiesEvent */.yb)(cacheId, submitValues);
                var gaParams = (0,lib.stringify)(PostConstants/* PostSearchGAParams */.fy, {
                  arrayFormat: "indices"
                });
                window.location.href = "".concat(Constants/* TABI_DOMAIN */.xQ, "/hotels?").concat((0,lib.stringify)(submitValues, {
                  arrayFormat: "indices"
                }), "&cache_id=").concat(cacheId, "&").concat(gaParams);
              })["catch"](function (errorResponse) {
                setIsSubmitting(false);

                if (errorResponse.errors) {
                  // エラー形式を合わせるために変換している
                  var _errors = Object.keys(errorResponse.errors).map(function (key) {
                    return (0,defineProperty/* default */.Z)({}, key, errorResponse.errors[key]);
                  });

                  (0,FormUtil/* convertServerErrorToForm */.fz)({
                    fieldMessages: _errors
                  }, setError);
                }
              }));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var fetchHotelDestinationSuggestionsAction = function fetchHotelDestinationSuggestionsAction(data) {
    var text = data.text,
        rest = (0,objectWithoutProperties/* default */.Z)(data, _excluded);

    appDispatch((0,hotelSuggestionSlice/* debouncedFetchHotelDestinationSuggestions */.y$)({
      params: _objectSpread({
        text: text
      }, rest)
    }));
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: blockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
      css: titleStyle,
      children: t("lp.searchHotelByDestinationTitle", {
        destination: ((_region = region) === null || _region === void 0 ? void 0 : _region.name) || ""
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* FormProvider */.RV, _objectSpread(_objectSpread({}, methods), {}, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
        onSubmit: handleFormSubmit,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: firstBlockStyle,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: destBlockStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelDestinationBlock/* HotelDestinationBlock */.h, {
              fetchHotelDestinationSuggestions: fetchHotelDestinationSuggestionsAction,
              suggestOptions: {
                excluded_code: "JP"
              },
              labelColorStyleKey: "default",
              borderColorStyleKey: "secondary"
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelDatePickerBlock/* HotelDatePickerBlock */.F, {
            labelColorStyleKey: "default",
            borderColorStyleKey: "secondary"
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuestsBlock/* GuestsBlock */.J, {
          labelColorStyleKey: "default",
          borderColorStyleKey: "secondary"
        }), errors && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormErrorsBlock/* FormErrorsBlock */.R, {
            namespace: FormConstants/* FormNamespaces.hotel */.Z.hotel,
            errors: errors,
            hideValidationErrors: true
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: submitBlockStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWithLoader/* ButtonWithLoader */.O, {
            type: "submit",
            disabled: isSubmitting,
            isLoading: isSubmitting,
            children: "\u691C \u7D22"
          })
        })]
      })
    }))]
  });
};
var submitBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, " 0 ", spaceStyle/* space.atom2x */.D.atom2x, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{padding-top:", spaceStyle/* space.atom2x */.D.atom2x, ";width:50%;margin-left:auto;margin-right:0;}" + ( true ? "" : 0),  true ? "" : 0);
var blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("margin:0 auto;padding:", spaceStyle/* space.atom */.D.atom, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{max-width:", maxWidthStyle/* maxWidth.page1colWide */.k.page1colWide, ";margin:", spaceStyle/* space.atom */.D.atom, " auto ", spaceStyle/* space.atom2x */.D.atom2x, ";box-sizing:border-box;}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{padding:0 ", spaceStyle/* space.atom */.D.atom, ";}" + ( true ? "" : 0),  true ? "" : 0);
var firstBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, " 0 0;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{display:flex;}" + ( true ? "" : 0),  true ? "" : 0);
var destBlockStyle =  true ? {
  name: "82a6rk",
  styles: "flex:1"
} : 0;
var titleStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom */.D.atom, ";letter-spacing:0.1em;font-size:", typographyStyle/* fontSize.headline */.JB.headline, ";color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{font-size:", typographyStyle/* fontSize.title */.JB.title, ";}" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/utils/ScrollUtil.ts
var ScrollUtil = __webpack_require__(75215);
// EXTERNAL MODULE: ./main/javascripts/utils/UrlUtil.tsx
var UrlUtil = __webpack_require__(28048);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 3 modules
var format = __webpack_require__(32912);
// EXTERNAL MODULE: ./main/javascripts/components/block/MainBlock.tsx
var block_MainBlock = __webpack_require__(26079);
// EXTERNAL MODULE: ./main/javascripts/components/block/BasicBlock.tsx
var BasicBlock = __webpack_require__(12160);
// EXTERNAL MODULE: ./main/javascripts/components/molecules/Lp/BlockTitle/index.ts + 2 modules
var BlockTitle = __webpack_require__(7696);
// EXTERNAL MODULE: ./main/javascripts/components/card/Card.tsx
var Card = __webpack_require__(99615);
// EXTERNAL MODULE: ./main/javascripts/components/card/CardTitle.tsx
var CardTitle = __webpack_require__(39733);
// EXTERNAL MODULE: ./main/javascripts/components/card/CardImage.tsx + 1 modules
var CardImage = __webpack_require__(4325);
// EXTERNAL MODULE: ./main/javascripts/components/StarRating/StarNumRating.tsx + 1 modules
var StarNumRating = __webpack_require__(49574);
// EXTERNAL MODULE: ./main/javascripts/components/card/CardColumn.tsx
var CardColumn = __webpack_require__(34216);
// EXTERNAL MODULE: ./main/javascripts/slices/paramSlice.ts
var paramSlice = __webpack_require__(9195);
;// CONCATENATED MODULE: ./main/javascripts/features/lp/hotelDstRegion/components/HotelRecommendedCard.tsx
function HotelRecommendedCard_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
















var HotelRecommendedCard = function HotelRecommendedCard(props) {
  var hotel = props.hotel,
      param = props.param;
  var router = (0,next_router.useRouter)();

  var onClick = function onClick() {
    router.push("/hotels/".concat(hotel.id, "?").concat((0,paramSlice/* hotelIndexParamToUrlParam */.kP)(param)));
  }; // nullにした方が良い?


  var url = hotel.defaultImage ? hotel.defaultImage.url : "";
  var rating = hotel.rating ? hotel.rating : 0;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: HotelRecommendedCard_blockStyle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Card */.Z, {
      onClick: onClick,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: imageBlockStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardImage/* CardImage */.x, {
          url: url
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: innerStyle,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
          children: hotel.name
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: ratingBlockStyle,
          children: [rating > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: ratingStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StarNumRating/* StarNumRating */.p, {
              rating: rating
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: rankTagStyle,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
              css: rankLabelStyle,
              children: "RANK"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
              css: rankValueStyle,
              children: hotel.rank
            })]
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: roomBlockStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardColumn/* CardColumn */.x, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              css: roomInfoStyle,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: recommendedSentenceStyle,
                children: hotel.hotelRecommendedSentences && hotel.hotelRecommendedSentences.map(function (sentence, index) {
                  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                    children: sentence
                  }, index);
                })
              })
            })
          })
        })]
      })]
    })
  });
};
var HotelRecommendedCard_blockStyle =  true ? {
  name: "e0dnmk",
  styles: "cursor:pointer"
} : 0;
var innerStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("flex:1;padding:", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var imageBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("aspect-ratio:2/1;overflow:hidden;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{aspect-ratio:auto;height:auto;width:33.333%;}" + ( true ? "" : 0),  true ? "" : 0);
var ratingStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom0_5x */.D.atom0_5x, " ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var roomBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("align-items:center;&:before{content:\"\";border-top:1px solid ", colorStyle/* borderColor.primaryLightColor */.tv.primaryLightColor, ";display:block;width:100%;margin:", spaceStyle/* space.atom1_5x */.D.atom1_5x, " ", spaceStyle/* space.atom */.D.atom, " 0;padding:", spaceStyle/* space.atom */.D.atom, " 0 0;}" + ( true ? "" : 0),  true ? "" : 0);
var roomInfoStyle =  true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0;
var rankTagStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";padding:0 0.25rem;background:", colorStyle/* borderColor.primaryDarkColor */.tv.primaryDarkColor, ";color:#fff;margin:0 ", spaceStyle/* space.atom */.D.atom, " 0.3rem;align-self:center;border-radius:2px;" + ( true ? "" : 0),  true ? "" : 0);
var rankLabelStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("vertical-align:middle;padding-right:0.3rem;font-size:", typographyStyle/* fontSize.smallest */.JB.smallest, ";" + ( true ? "" : 0),  true ? "" : 0);
var rankValueStyle =  true ? {
  name: "1989ovb",
  styles: "vertical-align:middle"
} : 0;
var ratingBlockStyle =  true ? {
  name: "zjik7",
  styles: "display:flex"
} : 0;
var recommendedSentenceStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, ";color:", colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor, ";font-size:", typographyStyle/* fontSize.body */.JB.body, ";line-height:", typographyStyle/* lineHeight.body2 */.Nv.body2, ";" + ( true ? "" : 0),  true ? "" : 0);
;// CONCATENATED MODULE: ./main/javascripts/features/lp/hotelDstRegion/components/HotelRecommendedList.tsx




var HotelRecommendedList = function HotelRecommendedList(props) {
  var hotels = props.hotels,
      param = props.param;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: hotels.map(function (hotel) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelRecommendedCard, {
        hotel: hotel,
        param: param
      }, hotel.id);
    })
  });
};
// EXTERNAL MODULE: ./main/javascripts/components/molecules/Lp/RegionList/index.ts + 2 modules
var RegionList = __webpack_require__(93478);
// EXTERNAL MODULE: ./main/javascripts/components/molecules/Breadcrumb/index.ts + 2 modules
var Breadcrumb = __webpack_require__(99581);
// EXTERNAL MODULE: ./main/javascripts/components/pager/Pager.tsx + 3 modules
var Pager = __webpack_require__(55219);
// EXTERNAL MODULE: ./main/javascripts/components/chat/ChatEntry.tsx
var ChatEntry = __webpack_require__(35004);
;// CONCATENATED MODULE: ./main/javascripts/features/lp/hotelDstRegion/components/LpHotelDstRegionIndexMain.tsx



function LpHotelDstRegionIndexMain_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









 // import { nl2br } from "main/javascripts/utils/StringUtil";

 // import { BlockSubTitle } from "main/javascripts/components/molecules/Lp/BlockSubTitle";
// import { Paragraph } from "main/javascripts/components/atoms/Paragraph";
















var LpHotelDstRegionIndexMain = function LpHotelDstRegionIndexMain(_ref) {
  var regionId = _ref.regionId;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["component"]),
      t = _useTranslation.t;

  var dispatch = (0,store/* useAppDispatch */.TL)();
  var blockRef = (0,react.useRef)();
  var router = (0,next_router.useRouter)();
  var hotelDestinationRegion = (0,store/* useAppSelector */.CG)(lpHotelDstRegionSlice/* hotelDestinationRegionSelector */.VE);
  var page = (0,store/* useAppSelector */.CG)(lpHotelDstRegionSlice/* pageSelector */._p);
  var totalNum = (0,store/* useAppSelector */.CG)(lpHotelDstRegionSlice/* totalNumSelector */.rN);
  var numPerPage = (0,store/* useAppSelector */.CG)(lpHotelDstRegionSlice/* numPerPageSelector */.KD);
  var breadcrumbData = [{
    url: "/",
    label: t("label:common.home")
  }];

  if (hotelDestinationRegion) {
    if (hotelDestinationRegion.country && hotelDestinationRegion.region.regionType !== "country") {
      var country = hotelDestinationRegion.country;
      breadcrumbData.push({
        url: "/lp/hotels/dst_regions/".concat(country.code),
        label: country.name
      });
    }

    breadcrumbData.push({
      label: hotelDestinationRegion.region.name
    });
  }

  var pagerHandler = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(page) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch((0,lpHotelDstRegionSlice/* fetchLpHotelDstRegions */.Ib)({
                id: regionId,
                page: page
              }));
              (0,UrlUtil/* pushUrl */.ir)({
                page: page
              }, router);
              (0,ScrollUtil/* scrollToElement */.kI)(blockRef.current, 100); // window.location.href = `${window.location.pathname}?page=${page}`;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function pagerHandler(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var renderBreadcrumb = function renderBreadcrumb() {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: breadcrumbBlockStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: breadcrumbInnerStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: breadcrumbStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Breadcrumb/* Breadcrumb */.a, {
            linkData: breadcrumbData
          })
        })
      })
    });
  };

  var renderHotelList = function renderHotelList() {
    if (!hotelDestinationRegion || !hotelDestinationRegion.region) {
      return null;
    }

    var region = hotelDestinationRegion.region;
    var regionName = hotelDestinationRegion.region.name;
    var indexParam = {};
    indexParam.destinationId = region.id;
    indexParam.destination = region.name;
    indexParam.destinationType = "region";
    var today = new Date();
    var departureDate = (0,addMonths["default"])(today, 2);
    var dateFormat = "yyyy/LL/dd";
    indexParam.checkinDate = (0,format["default"])(departureDate, dateFormat);
    indexParam.checkoutDate = (0,format["default"])((0,addDays["default"])(departureDate, 5), dateFormat);
    var hotels = hotelDestinationRegion.hotels;

    if (hotels && hotels.length > 0) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: priceListBlockStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasicBlock/* BasicBlock */.M, {
          styleKey: "blockWide",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
              css: LpHotelDstRegionIndexMain_titleStyle,
              ref: blockRef,
              children: t("lp.hotelRecommendedListTitle", {
                destination: regionName
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelRecommendedList, {
              hotels: hotels,
              param: indexParam
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              css: pagerBlockStyle,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Pager/* Pager */.u, {
                totalNum: totalNum,
                page: page,
                numPerPage: numPerPage,
                handler: pagerHandler
              })
            })]
          })
        })
      });
    }

    return null;
  }; // const renderDescription = (): JSX.Element | null => {
  //   if (!hotelDestinationRegion) {
  //     return null;
  //   }
  //   const regionName: string = hotelDestinationRegion.region.name;
  //   if (hotelDestinationRegion.region.description) {
  //     return (
  //       <>
  //         <BlockTitle>
  //           {t("lp.destinationAbout", { destination: regionName })}
  //         </BlockTitle>
  //         <Paragraph>
  //           {nl2br(hotelDestinationRegion.region.description)}
  //         </Paragraph>
  //       </>
  //     );
  //   }
  //   return null;
  // };
  // const renderBestSeason = (): JSX.Element | null => {
  //   if (!hotelDestinationRegion) {
  //     return null;
  //   }
  //   const regionName: string = hotelDestinationRegion.region.name;
  //   if (hotelDestinationRegion.region.bestSeason) {
  //     return (
  //       <section>
  //         <BlockSubTitle>
  //           {t("lp.destinationBestSeason", { destination: regionName })}
  //         </BlockSubTitle>
  //         <Paragraph>
  //           {nl2br(hotelDestinationRegion.region.bestSeason)}
  //         </Paragraph>
  //       </section>
  //     );
  //   }
  //   return null;
  // };
  // const renderComment = (): JSX.Element | null => {
  //   if (!hotelDestinationRegion) {
  //     return null;
  //   }
  //   if (hotelDestinationRegion.region.comment) {
  //     return (
  //       <section>
  //         <BlockSubTitle>{t("lp.conciergeComment")}</BlockSubTitle>
  //         <Paragraph>{nl2br(hotelDestinationRegion.region.comment)}</Paragraph>
  //       </section>
  //     );
  //   }
  //   return null;
  // };


  var renderSurroundingRegions = function renderSurroundingRegions() {
    if (!hotelDestinationRegion) {
      return null;
    }

    if (hotelDestinationRegion.surroundingRegions) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasicBlock/* BasicBlock */.M, {
        styleKey: "blockWide",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BlockTitle/* BlockTitle */.b, {
            children: t("lp.surroundingRegions")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RegionList/* RegionList */.Y, {
            regions: hotelDestinationRegion.surroundingRegions,
            linkUrl: "/lp/hotels/dst_regions/"
          })]
        })
      });
    }

    return null;
  };

  if (!hotelDestinationRegion) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(block_MainBlock/* MainBlock */.R, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: LpHotelDstRegionIndexMain_blockStyle,
      children: [renderBreadcrumb(), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("article", {
        children: [renderHotelList(), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasicBlock/* BasicBlock */.M, {
          styleKey: "blockWide",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("section", {
            css: chatEntryBlockStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChatEntry/* ChatEntry */.o, {})
          })
        }), renderSurroundingRegions()]
      })]
    })
  });
};
var LpHotelDstRegionIndexMain_blockStyle =  true ? {
  name: "8cz73a",
  styles: "padding:0 0 3rem"
} : 0; // const infoBlockStyle = css`
//   padding: ${space.atom3x} ${space.atom} ${space.atom2x};
//   max-width: ${maxWidth.page1colWide};
//   margin: 0 auto;
//   box-sizing: border-box;
// `;

var chatEntryBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("margin:", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom */.D.atom, " 0;" + ( true ? "" : 0),  true ? "" : 0);
var priceListBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:0 0 ", spaceStyle/* space.atom2x */.D.atom2x, ";max-width:100%;box-sizing:border-box;background-color:", colorStyle/* backgroundColor.secondaryLightColor */.Cz.secondaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var LpHotelDstRegionIndexMain_titleStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";line-height:", typographyStyle/* lineHeight.headline1 */.Nv.headline1, ";color:", colorStyle/* accentColor.secondaryColor2 */.z.secondaryColor2, ";padding:", spaceStyle/* space.atom */.D.atom, ";font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";letter-spacing:0.1em;margin:0.5rem 0;position:relative;padding-bottom:", spaceStyle/* space.atom2x */.D.atom2x, ";&:before{content:\"\";position:absolute;bottom:0;display:block;height:1px;width:calc(100% - ", spaceStyle/* space.atom2x */.D.atom2x, ");background:#ddd;}&:after{content:\"\";position:absolute;bottom:0;display:block;height:1px;width:3rem;background:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{font-size:", typographyStyle/* fontSize.headline */.JB.headline, ";}" + ( true ? "" : 0),  true ? "" : 0);
var breadcrumbBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, " 0 ", spaceStyle/* space.atom */.D.atom, ";max-width:100%;box-sizing:border-box;background-color:", colorStyle/* backgroundColor.secondaryLightColor */.Cz.secondaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var breadcrumbInnerStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("max-width:", maxWidthStyle/* maxWidth.page1colWide */.k.page1colWide, ";margin:0 auto;padding:0 ", spaceStyle/* space.atom2x */.D.atom2x, ";box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0);
var breadcrumbStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding-bottom:", spaceStyle/* space.atom */.D.atom, ";border-bottom:1px solid ", colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var pagerBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("max-width:30rem;margin:2rem auto ", spaceStyle/* space.atom2x */.D.atom2x, ";" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/components/footer/Footer.tsx
var Footer = __webpack_require__(77747);
;// CONCATENATED MODULE: ./pages/lp/hotels/dst_regions/[regionId].tsx






















// loadVConsole(2000);
function HotelDstRegionsShow(props) {
  var hotelDestinationRegion = props.hotelDestinationRegion,
      numPerPage = props.numPerPage,
      totalNum = props.totalNum,
      _props$metaTags = props.metaTags,
      metaTags = _props$metaTags === void 0 ? {} : _props$metaTags,
      locale = props.locale,
      regionId = props.regionId;
  var router = (0,next_router.useRouter)();
  var page = 1;
  var title = metaTags.title,
      description = metaTags.description,
      noindex = metaTags.noindex;
  var origin = Constants/* HOST */.M5;

  var _useState = (0,react.useState)(false),
      completed = _useState[0],
      setCompleted = _useState[1];

  (0,react.useEffect)(function () {
    var page = Number(router.query.page || 1);

    if (page > 1 && !completed) {
      store/* store.dispatch */.h.dispatch((0,lpHotelDstRegionSlice/* fetchLpHotelDstRegions */.Ib)({
        id: regionId,
        page: page
      }));
      setCompleted(true);
    }
  }, [router]);
  (0,useConstructor/* useConstructor */.g)(function () {
    if (hotelDestinationRegion) {
      store/* store.dispatch */.h.dispatch((0,lpHotelDstRegionSlice/* initHotelDestination */.RT)({
        hotelDestinationRegion: hotelDestinationRegion,
        metaTags: metaTags,
        totalNum: totalNum,
        page: page,
        numPerPage: numPerPage
      }));
    }

    if (i18n/* default.language */.Z.language !== locale) {
      void i18n/* default.changeLanguage */.Z.changeLanguage(locale);
    }

    globalStyle/* extended.css */.bU.css(globalStyle/* defaultStyles */.jF[globalStyle/* GLOBALS */.UH]);
  });
  (0,useUserAccount/* useUserAccount */.q)(store/* store */.h);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(es/* Provider */.zt, {
    store: store/* store */.h,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MainHead/* MainHead */.I, {
      origin: origin,
      title: title,
      description: description,
      noindex: !!noindex
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(I18nextProvider/* I18nextProvider */.a, {
      i18n: i18n/* default */.Z,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderContainer/* HeaderContainer */.g, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MainBlock/* MainBlock */.R, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchBlock/* SearchBlock */.w, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchHotel, {})
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LpHotelDstRegionIndexMain, {
            regionId: regionId
          })]
        }, 1), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* Footer */.$, {})]
      })
    })]
  });
}

var __N_SSG = true;
/* harmony default export */ var _regionId_ = (HotelDstRegionsShow);

/***/ }),

/***/ 95835:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lp/hotels/dst_regions/[regionId]",
      function () {
        return __webpack_require__(18125);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8053,9481,9113,5057,1906,2912,9923,4170,4602,2802,853,7744,8808,722,7886,4349,6129,8740,9918,5147,4750,1185,5567,6852,5543,8452,9938,5219,4506,5624,6423,9774,2888,179], function() { return __webpack_exec__(95835); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);